var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7753 15.0967H3.0269C1.80171 15.0967 0.803955 14.1006 0.803955 12.8737V3.10869C0.803955 1.8918 1.79341 0.902344 3.0103 0.902344H7.6604V1.89844H3.0103C2.34292 1.89844 1.80005 2.44131 1.80005 3.10869V12.8754C1.80005 13.5511 2.34956 14.1022 3.0269 14.1022H12.777C13.4527 14.1022 14.0039 13.5527 14.0039 12.8754V8.24023H15V12.8737C14.9983 14.1006 14.0022 15.0967 12.7753 15.0967Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9893 5.06055H13.9932V1.90625H10.8389V0.910156H14.9893V5.06055Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1477 1.04688L14.8519 1.75111L8.26732 8.33574L7.56308 7.6315L14.1477 1.04688Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlack);
export default __webpack_public_path__ + "static/media/download-black.59a341e0deaecc6229dfbdfb7c01931e.svg";
export { ForwardRef as ReactComponent };